import * as React from 'react';
import * as PropTypes from 'prop-types';
import { trackView, LISTING_TYPE } from '@reverbdotcom/commons/dist/tracker';

class OtherBuyersWithListingInCart extends React.Component {
  componentDidMount() {
    trackView({
      componentName: 'OtherBuyersWithListingInCart',
      type: LISTING_TYPE,
      ids: [this.props.listingId],
    });
  }

  render() {
    return (
      <p className="in-demand-tag">
        <span className="in-demand-tag__title">
          {I18n.t('js.listings.dontMissOut')}
        </span>
        <br />
        {I18n.t('js.listings.peopleHaveInCarts', { count: this.props.otherBuyersWithListingInCartCount })}
      </p>
    );
  }
}

OtherBuyersWithListingInCart.propTypes = {
  otherBuyersWithListingInCartCount: PropTypes.string.isRequired,
  listingId: PropTypes.string.isRequired,
};

export default OtherBuyersWithListingInCart;



// WEBPACK FOOTER //
// ./javascripts/components/listings/other_buyers_with_listing_in_cart.jsx